"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var store_1 = require("../../store");
exports.default = (function (props) {
    var setAppConfig = store_1.useActions(function (actions) { return actions.ui.setAppConfig; });
    setAppConfig(props);
    return react_1.default.createElement(react_1.default.Fragment, null);
});
